import React from "react";
import styled from "styled-components";

export interface LogoImageProps {
    listId: string,
    logoUrl: string;
    url?: string;
}

const LogoImageContainer = styled.div<{ hasUrl: boolean; }>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 62px;
    overflow-x: hidden;
    cursor: ${p => p.hasUrl === true ? "pointer" : "default"};
`;

export const LogoImage = (props: LogoImageProps) => {
    const hasUrl = props.url !== undefined && props.url !== "" && props.url !== null;
    const onLogoClick = (event: React.MouseEvent) => {
        if (hasUrl) {
            const url = (props.url + "").indexOf("://") !== -1 ? props.url : "http://" + props.url;
            window.open(url, "_blank");
        }
    };

    return (
        <LogoImageContainer hasUrl={hasUrl}>
            <img src={props.logoUrl} alt="" onClick={onLogoClick} style={{ width: "auto", maxHeight: "60px" }} />
        </LogoImageContainer>
    );
}